import { LogLevel } from '@azure/msal-browser';

/**
 * Ingresa aquí los flujos de usuario y las políticas personalizadas para tu aplicación B2C.
 * Para obtener más información sobre los flujos de usuario, visita: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * Para obtener más información sobre las políticas personalizadas, visita: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
const BASE_URL = `${process.env.REACT_APP_BASE_NAME  || "/" }`; 

const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantName = process.env.REACT_APP_TENANT_NAME;
const state = process.env.REACT_APP_STATE;
const nonce = process.env.REACT_APP_NONCE; 

const flows = {
    localAccSignIn: 'B2C_1_main_flow', // por ejemplo, B2C_1_main_flow
    msid: 'B2C_1_msid',
}
const activeFlow = flows.localAccSignIn;

export const b2cPolicies = {
    names: {
        signUpSignIn: activeFlow
    },
    authorities: {
        signUpSignIn: {
            authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${activeFlow}`,
        }
    },
    authorityDomain: `${tenantName}.b2clogin.com`,
    authorityMetadata: `{"token_endpoint": "https://login.microsoftonline.com/${tenantName}/oauth2/v2.0/token", "token_endpoint_auth_methods_supported": ["client_secret_post", "private_key_jwt", "client_secret_basic"], "jwks_uri": "https://login.microsoftonline.com/${tenantName}/discovery/v2.0/keys", "response_modes_supported": ["query", "fragment", "form_post"], "subject_types_supported": ["pairwise"], "id_token_signing_alg_values_supported": ["RS256"], "response_types_supported": ["code", "id_token", "code id_token", "id_token token"], "scopes_supported": ["' + clientId + '", "openid", "profile", "email", "offline_access"], "issuer": "https://login.microsoftonline.com/' + tenantName + '/v2.0", "request_uri_parameter_supported": false, "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo", "authorization_endpoint": "https://login.microsoftonline.com/${tenantName}/oauth2/v2.0/authorize", "device_authorization_endpoint": "https://login.microsoftonline.com/${tenantName}/oauth2/v2.0/devicecode", "http_logout_supported": true, "frontchannel_logout_supported": true, "end_session_endpoint": "https://login.microsoftonline.com/${tenantName}/oauth2/v2.0/logout", "claims_supported": ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], "kerberos_endpoint": "https://login.microsoftonline.com/${tenantName}/kerberos", "tenant_region_scope": null, "cloud_instance_name": "microsoftonline.com", "cloud_graph_host_name": "graph.windows.net", "msgraph_host": "graph.microsoft.com", "rbac_url": "https://pas.windows.net"}`
};

/**
 * Objeto de configuración que se pasa a la instancia MSAL al crearla.
 * Para obtener una lista completa de los parámetros de configuración de MSAL.js, visita:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: clientId, // Este es el único campo obligatorio que debes proporcionar.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Elige SUSI como tu autoridad predeterminada.
        knownAuthorities: [b2cPolicies.authorityDomain], // Marca el dominio de tu inquilino B2C como confiable.
        redirectUri: BASE_URL+"blank.html", // Debes registrar esta URI en Azure Portal/App Registration. Por defecto a window.location.origin
        postLogoutRedirectUri: BASE_URL, // Indica la página a la que navegar después de cerrar la sesión.
        navigateToLoginRequestUrl: false, // Si es "true", navegará de vuelta a la ubicación de la solicitud original antes de procesar la respuesta del código de autenticación.
        authorityMetadata: b2cPolicies.authorityMetadata,
        scopes: ["user.read", "openid", "profile", "email"], // Agrega los alcances necesarios para OpenID Connect
        state:state,
        nonce:nonce,
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configura la ubicación del caché. "sessionStorage" es más seguro, pero "localStorage" te da SSO entre pestañas.
        storeAuthStateInCookie: false, // Establécelo en "true" si tienes problemas en IE11 o Edge
    },
    system: {
        asyncPopups: true, // Habilitar ventanas emergentes asíncronas
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        //console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        //console.debug(message);
                        return;
                    case LogLevel.Warning:
                        //console.warn(message);
                        return;
                    default:
                        //console.log(message);
                        return;
                }
            },
        },
    },
};

export const authScopes = {
    scopes: ["user.read", "openid", "profile", "email"],
};
